import { render, staticRenderFns } from "./Tours.vue?vue&type=template&id=00c5ba80&scoped=true&"
import script from "./Tours.vue?vue&type=script&lang=js&"
export * from "./Tours.vue?vue&type=script&lang=js&"
import style0 from "./Tours.vue?vue&type=style&index=0&id=00c5ba80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c5ba80",
  null
  
)

component.options.__file = "Tours.vue"
export default component.exports